import React from "react";
import { exportToolTransfer } from "@/modules/pg/plan/toolTransfer/toolTransferPrint";
import { match } from "react-router";
import { History, Location } from "history";

type Props = {
    match: match<{ order_external_id: string; process_num: string }>;
    history: History;
    location: Location;
};

class ToolTransfer extends React.Component<Props> {
    async componentDidMount() {
        try {
            const { order_external_id, process_num } = this.props.match.params;
            await exportToolTransfer(order_external_id, process_num);
            this.props.history.goBack();
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return <div />;
    }
}

export default ToolTransfer;
